const StockGroupConfig = [
  {
    name: "Stock_Group_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Group_Name",
        label: "Group Name",
        type: "text",
        min: 2,
        isRequired: true,
        ValidationType: "VALID_STRING",
        autoFocus: true,
      },
      {
        id: Math.random() * 10,
        name: "Group_Under",
        label: "Group Under ",
        type: "InputDropForQuery",
        masterName: "Stock_Group",
        min: 2,
        max: Infinity,
        // isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "HSN_Code",
        label: "HSN Code",
        type: "InputDropForQuery",
        masterName: "HSN_Code",
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "GST_Rate",
        label: "GST Rate",
        type: "text",
        // masterName: "Account_Group",
        // dropdowncontent: "",
        // min: 2,
        valueDependOn: {
          field: "HSN_Code",
          value: "GST_Percentage",
        },
        disabled: true,
        max: Infinity,
        isRequired: false,
      },
    ],
  },
];

export { StockGroupConfig };
